import React from 'react';
import {
    Box,
    Typography,
    Grid
} from '../../../node_modules/@mui/material/index';
import BeatsCustomerReportController from 'pages/Controller/BeatsCustomerReportController';
import Loader from 'components/Loader';
import ReportsTabs from 'utils/ReportsTabs';


const BeatCustomerReports = () => {
    const {
        cloading,
        customer,
        currentFY,
        previousFY,
        outstanding,
        sales, categoryComp,targetsales } = BeatsCustomerReportController();
    const customerPartyCode = customer?.party_code || customer?.partyCode || '';

    return (
        <div className="bg" style={{ display: 'block' }}>
            {cloading ? (
                <div className="overlay">
                    <Loader />
                    <span style={{ marginLeft: '10px' }}>Please wait, fetching reports...</span>
                </div>
            ) : null}
            <div className="cutrange">
                <span className="font20" style={{ fontWeight: 'bold' }}>BEATS Customer Reports</span>
            </div>

            <Box fullWidth sx={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }} >
                <Box sx={{ width: 'content', textAlign: 'center', fontWeight: 'bold', border: '2px solid white', borderRadius: '15px' }} p={2}>
                    <Typography variant={'span'}>{customer?.partyName} - {customerPartyCode}</Typography>
                </Box>
            </Box>

            <div>
                <Grid container spacing={3}>

                    <ReportsTabs
                        outstanding={outstanding}
                        sales={sales}
                        categoryComp={categoryComp}
                        targetsales={targetsales}
                        currentFY={currentFY}
                        previousFY={previousFY}
                    />
                </Grid>

            </div>
            {/* <div style={{marginTop:'10px'}}>
               
            </div> */}
        </div>
    );
};

export default BeatCustomerReports;
